import { render, staticRenderFns } from "./ExternalFacingView.vue?vue&type=template&id=1a5d8a71&scoped=true&"
import script from "./ExternalFacingView.vue?vue&type=script&lang=ts&"
export * from "./ExternalFacingView.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalFacingView.vue?vue&type=style&index=0&id=1a5d8a71&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5d8a71",
  null
  
)

export default component.exports